import { render, staticRenderFns } from "./SetBanner.vue?vue&type=template&id=8bfe657c"
import script from "./SetBanner.vue?vue&type=script&lang=js"
export * from "./SetBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports